import { Component, Input } from '@angular/core';

export interface NavigationItem {
    routerLink: string;
    tabLabelKey: string;
}

@Component({
    selector: 'ham-page-tab-navigation',
    template: `<div class="tabs-container">
        <ng-container *ngFor="let tab of navigationItems">
            <div
                class="tab"
                [class.active]="tab.active"
                [routerLink]="tab.routerLink"
                [queryParamsHandling]="'preserve'"
                routerLinkActive="active"
            >
                <div
                    *ngIf="
                        (mappingCashflowVersionMismatch &&
                            tab.tabLabelKey === 'aumico_reports_annualreport_navigation_cfs') ||
                            (mappingFCPVersionMismatch &&
                                tab.tabLabelKey === 'aumico_reports_annualreport_navigation_fcp');
                        else noMismatch
                    "
                    class="flex"
                    tooltipPosition="top"
                    backGroundHexColor="#1F2A37"
                    [hamTooltip]="'aumico_reports_tooltip_text_verify_data' | i18next"
                    [withArrow]="true"
                >
                    <span class="ham-icon">
                        <i class="exclamation-outline-icon"></i>
                    </span>
                    <span>
                        {{ tab.tabLabelKey | i18next }}
                    </span>
                </div>

                <ng-template #noMismatch>
                    {{ tab.tabLabelKey | i18next }}
                </ng-template>
            </div>

            <ng-content></ng-content>
        </ng-container>
    </div>`,
    styleUrls: ['./ham-page-tab-navigation.component.scss'],
})
export class HamPageTabNavigationComponent {
    @Input() navigationItems: NavigationItem[] = [];
    @Input() mappingCashflowVersionMismatch = false;
    @Input() mappingFCPVersionMismatch = false;
}
